
import { ParallaxEffect, ParallaxContext } from '@/render/parallax/ParallaxEffect';
import { BaseParallaxEffect } from '@/render/parallax/BaseParallaxEffect';

export class DataNodesEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
         const spacing = (200 + layerIndex * 100) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;
        const curTime = time * config.parallaxSpeed;

        ctx.strokeStyle = pc.color;
        ctx.fillStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        const points: {x: number, y: number}[] = [];
        for (let x = x1; x <= x2; x += spacing) {
            for (let y = y1; y <= y2; y += spacing) {
                const offX = Math.sin(curTime + x * 0.005) * spacing * 0.3;
                const offY = Math.cos(curTime + y * 0.005) * spacing * 0.3;
                points.push({ x: x + offX, y: y + offY });
            }
        }

        const draw = () => {
            for (let i = 0; i < points.length; i++) {
                const p1 = points[i];
                // Nodes
                ctx.beginPath();
                ctx.arc(p1.x, p1.y, 3 * scale, 0, Math.PI * 2);
                ctx.fill();

                // Connections
                for (let j = i + 1; j < Math.min(i + 4, points.length); j++) {
                    const p2 = points[j];
                    const dist = Math.hypot(p1.x - p2.x, p1.y - p2.y);
                    if (dist < spacing * 1.5) {
                        ctx.globalAlpha = (1 - dist / (spacing * 1.5)) * 0.5;
                        ctx.beginPath();
                        ctx.moveTo(p1.x, p1.y);
                        ctx.lineTo(p2.x, p2.y);
                        ctx.stroke();
                    }
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
